// Ensure all details are closed by default on page load
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.details-toogle').forEach(toggle => {
        toggle.classList.remove('open');
        toggle.classList.add('closed');
    });
    document.querySelectorAll('.product__subdetails').forEach(details => {
        details.classList.add('closed');
    });
});

document.addEventListener('click', (event) => {
    const toggle = event.target.closest('.details-toogle');
    if (!toggle) return;

    const details = toggle.nextElementSibling;
    if (!details?.classList.contains('product__subdetails')) return;

    // Toggle the 'closed' class on the details section
    const isClosed = details.classList.toggle('closed');

    // Add or remove the 'open' and 'closed' classes on the toggle element
    if (isClosed) {
        toggle.classList.remove('open');
        toggle.classList.add('closed');
    } else {
        toggle.classList.remove('closed');
        toggle.classList.add('open');
    }
});